// import React, { useEffect, useState, useMemo } from "react";
// import { Navigate, Route, Routes } from "react-router-dom";
// import { Snackbar, Alert } from "@mui/material";

// // Components
// import Login from "../Pages/Login";
// import MiniDrawer from "../Components/Drawer";
// import Error404 from "../Components/Error404";
// import HelmetMetaData from "../Components/HelmetMetaData";

// // Hooks and Utils
// import httpclient from "../Utils";
// import useTokenRefresh from "../Hooks/useTokenRefresh";

// // Component mappings
// import {
//   componentMapping,
//   sssAutoComponentMapping,
//   supervisorComponentMapping,
//   superAdminComponentMapping,
// } from "./componentMappings";

// // Static routes configuration
// import { staticRoutes } from "./staticRoutes";

// const Routing = () => {
//   // Token refresh hook
//   const {
//     getTokenRefreshed: refresh,
//     overlay,
//     open: tokenOpen,
//     message: tokenMessage,
//     messageState: tokenMessageState,
//     setOpen: setTokenOpen,
//   } = useTokenRefresh();

//   // State management
//   const [menuList, setMenuList] = useState([]);
//   const [notification, setNotification] = useState({
//     open: false,
//     message: "",
//     severity: "error",
//   });

//   // Get login data
//   const loginData = useMemo(() => {
//     const data = localStorage.getItem("user");
//     return data ? JSON.parse(data) : null;
//   }, []);

//   // Combined component mapping
//   const allComponentMappings = useMemo(
//     () => ({
//       ...componentMapping,
//       ...sssAutoComponentMapping,
//       ...supervisorComponentMapping,
//       ...superAdminComponentMapping,
//     }),
//     []
//   );

//   // Notification handlers
//   const showNotification = (message, severity = "error") => {
//     setNotification({ open: true, message, severity });
//   };

//   const hideNotification = (event, reason) => {
//     if (reason === "clickaway") return;
//     setNotification((prev) => ({ ...prev, open: false }));
//   };

//   // Error handler for API calls
//   const handleApiError = (err) => {
//     if (err.response?.status === 401) {
//       refresh();
//       setTokenOpen(tokenOpen);
//       showNotification(tokenMessage);
//     } else if ([422, 400].includes(err.response?.status)) {
//       const errorMessages = Object.values(
//         err.response.data.errors || {}
//       ).flat();
//       showNotification(errorMessages.join(", "));
//     } else {
//       showNotification(err.response?.data?.message || "An error occurred");
//     }
//   };

//   // Fetch menu list
//   const fetchMenuList = async () => {
//     try {
//       const { data } = await httpclient.get("menu-list");

//       if (data.status === 200) {
//         const excludedIds = [17, 18, 19, 24];
//         const filteredMenus = data.data.filter(
//           (item) => !excludedIds.includes(item.id)
//         );
//         setMenuList(filteredMenus);
//       } else {
//         showNotification(data.message);
//       }
//     } catch (err) {
//       handleApiError(err);
//     }
//   };

//   // Initialize menu list
//   useEffect(() => {
//     if (window.location.pathname !== "/login") {
//       fetchMenuList();
//     }
//   }, []);

//   // Protected Route Component
//   const ProtectedRoute = ({ children }) => {
//     const isAuthenticated = localStorage.getItem("token");

//     if (!isAuthenticated) {
//       return <Navigate to="/login" replace />;
//     }

//     return (
//       <MiniDrawer menuList={menuList} isStaticRoute={false}>
//         {children}
//       </MiniDrawer>
//     );
//   };

//   // Dynamic route renderer
//   const renderDynamicRoute = (menu, isSubMenu = false, isChild = false) => {
//     const Component = allComponentMappings[menu.component];

//     if (!Component) {
//       return (
//         <Route
//           key={menu.id}
//           path={menu.path}
//           element={
//             <ProtectedRoute>
//               <Error404 overlay={overlay} />
//             </ProtectedRoute>
//           }
//         />
//       );
//     }

//     const commonProps = {
//       permissions: menu.permissions,
//       request_name: menu.request_name,
//       loginValue: loginData,
//     };

//     return (
//       <Route
//         key={menu.id}
//         path={menu.path}
//         element={
//           <ProtectedRoute>
//             <Component {...commonProps} />
//           </ProtectedRoute>
//         }
//       />
//     );
//   };

//   // Recursive menu renderer - supports unlimited nesting levels
//   const renderMenuRoutes = (menuItems) => {
//     return menuItems.map((menu) => (
//       <React.Fragment key={menu.id}>
//         {renderDynamicRoute(menu)}
//         {menu.sub_menu?.map((subMenu) => (
//           <React.Fragment key={subMenu.id}>
//             {renderDynamicRoute(subMenu, true)}
//             {/* Handle third level - check both children and sub_menu properties */}
//             {(subMenu.children || subMenu.sub_menu)?.map((thirdLevelMenu) => (
//               <React.Fragment key={thirdLevelMenu.id}>
//                 {renderDynamicRoute(thirdLevelMenu, false, true)}
//               </React.Fragment>
//             ))}
//           </React.Fragment>
//         ))}
//       </React.Fragment>
//     ));
//   };

//   return (
//     <div>
//       <HelmetMetaData title={loginData?.company_name} description="SyncCare" />

//       <Routes>
//         {/* Public routes */}
//         <Route path="/login" element={<Login />} />

//         {/* Static protected routes */}
//         {staticRoutes.map(({ path, component: Component, exact }) => (
//           <Route
//             key={path}
//             path={path}
//             element={
//               <ProtectedRoute>
//                 <Component />
//               </ProtectedRoute>
//             }
//           />
//         ))}

//         {/* Dynamic routes from menu */}
//         {menuList.length > 0 && renderMenuRoutes(menuList)}

//         {/* 404 fallback */}
//         <Route
//           path="*"
//           element={
//             <ProtectedRoute>
//               <Error404 />
//             </ProtectedRoute>
//           }
//         />
//       </Routes>

//       {/* Notification Snackbar */}
//       <Snackbar
//         open={notification.open}
//         autoHideDuration={6000}
//         onClose={hideNotification}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//       >
//         <Alert
//           onClose={hideNotification}
//           severity={notification.severity}
//           sx={{ width: "100%" }}
//         >
//           {notification.message}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default Routing;


import React, { useEffect, useState, useMemo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";

// Components
import Login from "../Pages/Login";
import PublicTrackingAuthGate from "../Pages/PublicTrackingAuthGate";
import MiniDrawer from "../Components/Drawer";
import Error404 from "../Components/Error404";
import HelmetMetaData from "../Components/HelmetMetaData";
import TodaysJobsNew from "../Pages/SSSAuto/Delivery/TodaysJobsNew";

// Hooks and Utils
import httpclient from "../Utils";
import useTokenRefresh from "../Hooks/useTokenRefresh";

// Component mappings
import {
  componentMapping,
  sssAutoComponentMapping,
  supervisorComponentMapping,
  superAdminComponentMapping,
} from "./componentMappings";

// Static routes configuration
import { staticRoutes } from "./staticRoutes";

const Routing = () => {
  // Token refresh hook
  const {
    getTokenRefreshed: refresh,
    overlay,
    open: tokenOpen,
    message: tokenMessage,
    messageState: tokenMessageState,
    setOpen: setTokenOpen,
  } = useTokenRefresh();

  // State management
  const [menuList, setMenuList] = useState([]);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  // Get login data
  const loginData = useMemo(() => {
    const data = localStorage.getItem("user");
    return data ? JSON.parse(data) : null;
  }, []);

  // Combined component mapping
  const allComponentMappings = useMemo(
    () => ({
      ...componentMapping,
      ...sssAutoComponentMapping,
      ...supervisorComponentMapping,
      ...superAdminComponentMapping,
    }),
    []
  );

  // Notification handlers
  const showNotification = (message, severity = "error") => {
    setNotification({ open: true, message, severity });
  };

  const hideNotification = (event, reason) => {
    if (reason === "clickaway") return;
    setNotification((prev) => ({ ...prev, open: false }));
  };

  // Error handler for API calls
  const handleApiError = (err) => {
    if (err.response?.status === 401) {
      refresh();
      setTokenOpen(tokenOpen);
      showNotification(tokenMessage);
    } else if ([422, 400].includes(err.response?.status)) {
      const errorMessages = Object.values(
        err.response.data.errors || {}
      ).flat();
      showNotification(errorMessages.join(", "));
    } else {
      showNotification(err.response?.data?.message || "An error occurred");
    }
  };

  // Fetch menu list
  const fetchMenuList = async () => {
    try {
      const { data } = await httpclient.get("menu-list");

      if (data.status === 200) {
        const excludedIds = [17, 18, 19, 24];
        const filteredMenus = data.data.filter(
          (item) => !excludedIds.includes(item.id)
        );
        setMenuList(filteredMenus);
      } else {
        showNotification(data.message);
      }
    } catch (err) {
      handleApiError(err);
    }
  };

  // Initialize menu list
  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/tracking"
    ) {
      fetchMenuList();
    }
  }, []);

  // Protected Route Component
  const ProtectedRoute = ({ children }) => {
    const isAuthenticated = localStorage.getItem("token");

    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    return (
      <MiniDrawer menuList={menuList} isStaticRoute={false}>
        {children}
      </MiniDrawer>
    );
  };

  // Dynamic route renderer
  const renderDynamicRoute = (menu, isSubMenu = false, isChild = false) => {
    // New "Today's Jobs" menu entry reuses the "Orders" component name in
    // the API response, but must render a separate page - override by path
    // instead of touching the shared Orders component mapping (which the
    // existing "Today Jobs"/"All Jobs" menu entries still rely on).
    if (menu.path === "/delivery/orders/todays") {
      return (
        <Route
          key={menu.id}
          path={menu.path}
          element={
            <ProtectedRoute>
              <TodaysJobsNew />
            </ProtectedRoute>
          }
        />
      );
    }

    const Component = allComponentMappings[menu.component];

    if (!Component) {
      return (
        <Route
          key={menu.id}
          path={menu.path}
          element={
            <ProtectedRoute>
              <Error404 overlay={overlay} />
            </ProtectedRoute>
          }
        />
      );
    }

    const commonProps = {
      permissions: menu.permissions,
      request_name: menu.request_name,
      loginValue: loginData,
    };

    return (
      <Route
        key={menu.id}
        path={menu.path}
        element={
          <ProtectedRoute>
            <Component {...commonProps} />
          </ProtectedRoute>
        }
      />
    );
  };

  // Recursive menu renderer - supports unlimited nesting levels
  const renderMenuRoutes = (menuItems) => {
    return menuItems.map((menu) => (
      <React.Fragment key={menu.id}>
        {renderDynamicRoute(menu)}
        {menu.sub_menu?.map((subMenu) => (
          <React.Fragment key={subMenu.id}>
            {renderDynamicRoute(subMenu, true)}
            {/* Handle third level - check both children and sub_menu properties */}
            {(subMenu.children || subMenu.sub_menu)?.map((thirdLevelMenu) => (
              <React.Fragment key={thirdLevelMenu.id}>
                {renderDynamicRoute(thirdLevelMenu, false, true)}
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </React.Fragment>
    ));
  };

  return (
    <div>
      <HelmetMetaData title={loginData?.company_name} description="SyncCare" />

      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/tracking" element={<PublicTrackingAuthGate />} />

        {/* Static protected routes */}
        {staticRoutes.map(({ path, component: Component, exact }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute>
                <Component />
              </ProtectedRoute>
            }
          />
        ))}

        {/* Dynamic routes from menu */}
        {menuList.length > 0 && renderMenuRoutes(menuList)}

        {/* 404 fallback */}
        <Route
          path="*"
          element={
            <ProtectedRoute>
              <Error404 />
            </ProtectedRoute>
          }
        />
      </Routes>

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={hideNotification}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={hideNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Routing;
